import React, { useState, useEffect } from 'react';
import { renderActionHistory } from '../Action/ActionHistoryColumnDefinition';
import { ErrorDisplay } from '../../../components/ErrorDisplay';
import ElementErrorBoundary from '../../../components/ErrorBoundary/ElementErrorBoundary';
import { useSdpdsReadOnlyOperation } from '../../../hooks/useSdpdsReadOnlyOperation';

export const ActionHistory = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [selectedTaskId, setSelectedTaskId] = useState(props.initialTaskId || null);
  const [deploymentActionResult, setDeploymentActionResult] = useState(null);

  const { refetch } = useSdpdsReadOnlyOperation({
    operation_name: "GetDeploymentActionExecutionHistory",
    payload: {
      taskId: selectedTaskId
    }
  });

  useEffect(() => {
    initializeHistory();
  }, []);

  useEffect(() => {
    const { initialTaskId } = props;
    if (initialTaskId && initialTaskId !== selectedTaskId) {
      updateTaskId(initialTaskId);
    }
  }, [props.initialTaskId]);

  const initializeHistory = () => {
    const { initialTaskId, nodeOperationsList } = props;

    if (initialTaskId) {
      refreshDeploymentActionHistory(initialTaskId);
    } else if (nodeOperationsList?.length > 0) {
      const latestOperation = nodeOperationsList[0];
      updateTaskId(latestOperation.taskID);
    }
  };

  const updateTaskId = (taskId) => {
    setSelectedTaskId(taskId);
    refreshDeploymentActionHistory(taskId);
  };

  const refreshDeploymentActionHistory = async (taskId) => {
    if (!taskId) {
      setIsError(true);
      return;
    }

    setIsLoading(true);
    setIsError(false);

    try {
      const result = await refetch({
        payload: {
          taskId
        }
      });

      if (!result.data?.sdpdsReadOnlyOperation) {
        throw new Error('Failed to fetch action history');
      }

      setDeploymentActionResult(result.data.sdpdsReadOnlyOperation);
      setIsLoading(false);
      setIsError(false);
    } catch (error) {
      setIsLoading(false);
      setIsError(true);
      setDeploymentActionResult(null);
    }
  };

  const refreshCurrentHistory = () => {
    if (selectedTaskId) {
      refreshDeploymentActionHistory(selectedTaskId);
    }
  };

  const [inputTaskId, setInputTaskId] = useState(props.initialTaskId || '');

  const handleTaskIdChange = (e) => {
    setInputTaskId(e.target.value);
  };

  useEffect(() => {
    if (selectedTaskId) {
      setInputTaskId(selectedTaskId);
    }
  }, [selectedTaskId]);

  const renderContent = () => {
    return renderActionHistory({
      isLoading,
      isError,
      selectedTaskId: inputTaskId,
      deploymentActionResult,
      handleTaskIdChange,
      refreshDeploymentActionHistory: (taskId) => refreshDeploymentActionHistory(taskId || inputTaskId)
    });
  };

    if (isError) {
      return <ErrorDisplay />;
    }

    return (
      <ElementErrorBoundary>
        {renderContent()}
      </ElementErrorBoundary>
    );
}
